import React, { useState } from 'react';
import './Account.css'
//import frontImg from '../../img/frontImg.jpg'
//import backImg from '../../img/backImg.jpg'
//import LOGO from '../../img/LOGO.png';
import { Link } from 'react-router-dom';




const Account = () => {
  
  const [emailLogin, setEmailLogin] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");
  const [showLoginModal, setShowLoginModal] = useState(false);

  const [fullNameSignup, setFullNameSignup] = useState("");
  const [emailSignup, setEmailSignup] = useState("");
  const [passwordSignup, setPasswordSignup] = useState("");
  const [showSignupModal, setShowSignupModal] = useState(false);

  const handleLoginSubmit = (event) => {
    event.preventDefault();
    if (!emailLogin || !passwordLogin) {
      setShowLoginModal(true);
    } else {
      // Your login authentication logic here
    }
  };

  const handleSignupSubmit = async (event) => {
    event.preventDefault();
    if (!fullNameSignup || !emailSignup || !passwordSignup) {
      setShowSignupModal(true);
    } else {

      
      
    }
  };


    return(
        <>

        <div className="login-nav">
            <ul>
                <li>
                <Link to="/" className='navbar-logo' >
                        <img src={"images/senlogo-black.png"} alt="" />
                </Link>
                </li>
            </ul>
        </div>
        
        <div className="login-body">

            <div className="login-container">

            <input type="checkbox" id="flip" />
    <div class="cover">
      <div class="front">
        <img src={"images/frontImg.jpg"} alt="" />
        <div class="text">
          <span class="text-1">An investment in knowledge pays <br /> the best interest.</span>
          <span class="text-2">Let's get connected</span>
        </div>
      </div>
      <div class="back">
        <img class="backImg" src={"images/backImg.jpg"} alt="" />
        <div class="text">
          <span class="text-1">Complete miles of journey <br /> with one step</span>
          <span class="text-2">Let's get started</span>
        </div>
      </div>
    </div>
    <div class="forms">
        <div class="form-content">
          <div class="login-form">
            <div class="title">LOGIN</div>
          <form action="#" onSubmit={handleLoginSubmit}>
            <div class="input-boxes">
              <div class="input-box">
                <i class="fas fa-envelope"></i>
                <input type="email" placeholder="Enter your email" 
                value={emailLogin}
                onChange={(event) => setEmailLogin(event.target.value)}
                 />

              </div>
              <div class="input-box">
                <i class="fas fa-lock"></i>
                <input type="password" placeholder="Enter your password"
                value={passwordLogin} 
                onChange={(event) => setPasswordLogin(event.target.value)}
                />

              </div>
              <div class="text"><a href="#a">Forgot password?</a></div>
              <div class="button input-box">
                <input type="submit" value="Sumbit" />
              </div>
              <div class="text sign-up-text">Don't have an account? <label for="flip">Sigup now</label></div>
            </div>
        </form>

        {showLoginModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <p>Please complete the form to continue</p>
            <button onClick={() => setShowLoginModal(false)}>Close</button>
          </div>
        </div>
      )}
        
      </div>

        <div class="signup-form">
          <div class="title">Signup</div>
        <form action="#" onSubmit={handleSignupSubmit}>
            <div class="input-boxes">
              <div class="input-box">
                <i class="fas fa-user"></i>
                <input type="text" placeholder="Enter your full name"
                value={fullNameSignup}
                onChange={(event) => setFullNameSignup(event.target.value)}
                />
              </div>
              <div class="input-box">
                <i class="fas fa-envelope"></i>
                <input type="email" placeholder="Enter your email"
                value={emailSignup}
                onChange={(event) => setEmailSignup(event.target.value)}
                />
              </div>
              <div class="input-box">
                <i class="fas fa-lock"></i>
                <input type="password" placeholder="Enter your password"
                value={passwordSignup}
                onChange={(event) => setPasswordSignup(event.target.value)}
                />
              </div>
              <div class="button input-box">
                <input type="submit" value="Sumbit" />
              </div>
              <div class="text sign-up-text">Already have an account? <label for="flip">Login now</label></div>
            </div>
      </form>

      {showSignupModal && (
        <div className="modal-overlay-signup">
          <div className="modal-content-sign-up">
            <p>Please complete the form to continue</p>
            <button onClick={() => setShowSignupModal(false)}>Close</button>
          </div>
        </div>
      )}

    </div>
    </div>
    </div>


            </div>
        </div>
        </>

    )
}

export default Account;
